// extracted by mini-css-extract-plugin
export default {"qr_img":"TokenPage_qr_img__VFBxB"};